import { DependencyList, EffectCallback, useEffect, useRef } from 'react'
import useStableCallback from './useStableCallback'

export const useEffectAfter = (fn: EffectCallback, deps: DependencyList, after: number = 1) => {
  const stableFn = useStableCallback(fn)
  const countRef = useRef(0)
  useEffect(() => {
    // eslint-disable-next-line no-plusplus
    countRef.current++
    if (countRef.current > after) {
      stableFn()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
